<template>
  <base-card :projectID="projectID"
             :categoryID="categoryID"
             :storyType="storyType"
             :isMarginless="isMarginless"
             :isRowLoading="isRowLoading"
             :isPinnableRow="isPinnableRow"
             :pinnedProjects="pinnedProjects"
             :disableLink="disableLink"
             :displayType="displayType"
             :flexibleHeight="true"
             :showBookmark="false"
             >
    <information :isRowLoading="isRowLoading"
                 :isBlank="isBlank">
      <owner :user="judgeApplicant"
             :texts="judgeUserAnswers"
             :hasJudgePollUserOptions="hasJudgePollUserOptions"/>
    </information>
    <div class="judge-container">
      <div class="categories-wrapper is-flex">
        <a v-for="(information,index) in judgePollUserOptions"
           :key="index" class="a-category">
          <span class="tag is-flex">{{information.tag}}</span>
        </a>
      </div>
    </div>
    <div class="bottom-container">
      <approve-decline
          @updateStatus="approveOrDeclineProject"
          :showPendingButton="showPendingButton"
          :showApproveButton="showApproveButton"
          :showDeclineButton="showDeclineButton"/>
      <div class="score-container">
        {{ `${judgeQuestionScore}/${judgeQuestionMaxScore}` }}
      </div>
    </div>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import ApproveDecline from '../UI/ApproveDecline.vue'
import visibility from '@/mixins/visibility'
import Information from '../UI/Information'
import imageProxy from '@/libs/image-proxy'
import Owner from '../UI/Owner'
export default {
  name: 'JudgeApplication',
  data: function () {
    return {
      projectApproved: '',
      projectExample: {
        judge: {
          information: ['PhD', 'Family Doctor']
        }
      }
    }
  },
  components: {
    Owner,
    BaseCard,
    Information,
    ApproveDecline
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    disableLink: Boolean,
    displayType: String,
    projectStatus: String
  },
  mixins: [base, visibility],
  computed: {
    judgePollUserOptions: function () {
      return this.$store.getters.getJudgePollUserOptions(this.projectID) || []
    },
    hasJudgePollUserOptions: function () {
      return this.judgePollUserOptions.length > 0
    },
    judgeQuestionMaxScore: function () {
      return this.$store.getters.getJudgingQuestionTotalScore
    },
    judgeQuestionScore: function () {
      if (this.project && this.project.pollSummary) {
        return this.project.pollSummary.pollResponseScore
      }
      return 0
    },
    judgeApplicant: function () {
      return this.$store.getters.getJudgingProjectById(this.projectID).user
    },
    judgeUserAnswers: function () {
      const judgeProject = this.$store.getters.getJudgingProjectById(this.projectID)
      if (!judgeProject || !judgeProject.pollSummary || !judgeProject.pollSummary.userAnswers) {
        return []
      }
      return this.$store.getters.getJudgingProjectById(this.projectID).pollSummary.userAnswers.map(m => m.answer)
    },
    showPendingButton: function () {
      return ['Approved', 'Declined'].includes(this.projectStatus)
    },
    showApproveButton: function () {
      return ['Pending', 'Declined'].includes(this.projectStatus)
    },
    showDeclineButton: function () {
      return ['Approved', 'Pending'].includes(this.projectStatus)
    }
  },
  methods: {
    avatar: function (url) {
      return imageProxy.thumbnail(url)
    },
    altImg: function (e) {
      e.target.src = 'https://www.engineering.com/static/purple-logo-icon.svg'
    },
    approveOrDeclineProject: function (value) {
      switch (value) {
        case 'Approved':
          this.projectApproved = 'Approved'
          break
        case 'Declined':
          this.projectApproved = 'Declined'
          break
        default:
          this.projectApproved = 'Pending'
          break
      }

      this.$store.dispatch('approveOrDeclineProject', {
        projectID: this.project.id, status: this.projectApproved, reason: this.reasonToSend
      }).then((response) => {
        if (response) {
          const { declined, approved } = response
          this.isProjectDeclined = declined
          this.isProjectApproved = approved
        }
      }, (error) => {
        this.error = error.message
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .judge-container{
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    overflow-y: auto;
  }
  .categories-wrapper {
    padding: 0.5rem 0.5rem 0.5rem 0.5rem;
    flex-wrap: wrap;
    justify-content: flex-start;
    a {
      color: $grey-medium;
    }
    .tag {
      background-color: #fff;
      border: 1px solid #a1a1a1;
      font-size: .6rem;
      margin: 0.15rem 0.3rem 0.3rem 0;
    }
  }
  .bottom-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 0.5rem 0.5rem 0.5rem;
    align-items: center;
  }
  .score-container {
    text-align: center;
    background-color: rgb(245, 60, 60);
    color: white;
    border-radius: 16px;
    width: 6rem;
    max-height: 1.5rem;
    position: absolute;
    top: .3rem;
    right: .3rem;
  }

</style>
